import { EditPage, NavigateBackButton } from '@contember/admin'
import * as React from 'react'
import { GenericPageForm } from '../forms'

export const GenericPageEditPage = (
	<EditPage
		entity="GenericPage(id = $id)"
		pageName="pageEdit"
		rendererProps={{
			title: 'Edit page',
			navigation: <NavigateBackButton to="pageList">Pages</NavigateBackButton>,
		}}
	>
		<GenericPageForm />
	</EditPage>
)
